<template>
  <div class="applt-page">
    <top-bar :topbarList="appltTopBarList"></top-bar>
    <el-radio-group v-model="currentAppltType" v-show="isShowAppltType">
      <el-radio-button label="wx">微信</el-radio-button>
      <el-radio-button label="TINYAPP">支付宝</el-radio-button>
      <el-radio-button label="IOTAPP" v-if="isOwn">IOT</el-radio-button>
      <el-radio-button label="dy">抖音</el-radio-button>
    </el-radio-group>
    <router-view
      :status="applitInfo && applitInfo.isAuth"
      @getMiniAppInfo="getMiniAppInfo"
    ></router-view>
  </div>
</template>

<script>
import { getMiniAppInfo, getMiniAppInfoAlipay, getDYMiniAppInfo } from "@/api";
import topBar from "@/components/topBar.vue";
import { mapState, mapActions } from "vuex";
import { appltIndexMixins } from "@/mixins/appltIndexMixins";

export default {
  mixins: [appltIndexMixins],
  data() {
    return {
      currentAppltType: "wx",
    };
  },
  computed: {
    isShowAppltType() {
      if (
        this.$route.path == "/applt/setting" ||
        this.$route.path == "/applt/pickuppoint" ||
        this.$route.path == "/appltCourse" ||
        this.$route.path == "/applt/createMiniProgram" ||
        this.$route.path == "/appltAliRegisterGuide" ||
        this.$route.path == "/applt/qrCode" ||
        this.$route.path == "/applt/userCode" ||
        this.$route.path == "/applt/customerIcon" ||
        this.$route.path == "/applt/decoration"
      )
        return false;
      return true;
    },
  },
  watch: {
    currentAppltType(val) {
      this.changeAppltType(val);
      this.getMiniAppInfo();
    },
    applitInfo: {
      handler: function (val) {
        if (
          (!val && this.$route.path != "/applt") ||
          (val && !val.isAuth && this.$route.path != "/applt")
        ) {
          this.$router.push({
            path: "/applt",
          });
        }
      },
      deep: true,
    },
  },
  components: {
    topBar,
  },
  mounted() {
    this.getMiniAppInfo();
    this.currentAppltType = this.appltType;
  },
  methods: {
    ...mapActions(["updateAppltInfo", "changeAppltType"]),
    getMiniAppInfo() {
      if (this.appltType == "wx") {
        getMiniAppInfo().then((res) => {
          if (res.code == 1) {
            if (res.data.categories) {
              res.data.categories = JSON.parse(res.data.categories);
            }
            if (res.data.authorizerAppId) {
              this.updateAppltInfo(res.data);
            } else {
              this.updateAppltInfo(null);
            }
          } else {
            this.updateAppltInfo(null);
          }
        });
      } else if (this.appltType == "dy") {
        getDYMiniAppInfo().then((res) => {
          if (res.code == 1) {
            if (res.data.categories) {
              res.data.categories = JSON.parse(res.data.categories);
            }
            if (res.data.authorizerAppId) {
              this.updateAppltInfo(res.data);
            } else {
              this.updateAppltInfo(null);
            }
          } else {
            this.updateAppltInfo(null);
          }
        });
      } else {
        getMiniAppInfoAlipay({
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            if (res.data.authorizerAppId) {
              this.updateAppltInfo(res.data);
            } else {
              this.updateAppltInfo(null);
            }
          } else {
            this.updateAppltInfo(null);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.applt-page {
  height: 100%;
  .el-radio-group {
    margin: 20px 0 0 20px;
  }
  .content-page {
    height: calc(100% - 110px);
  }
}
</style>
